<template>
  <BaseModal
    @close="close"
    class="modal-edit"
  >
    <div class="modal-edit-container">
      <div @click="close" class="icon icon-dc_phone_icon_all_close"></div>
      <div class="modal-edit-header">
        <div class="modal-edit-header-title">{{lang.title}}</div>
      </div>
      <slot></slot>
      <div class="modal-edit-footer">
        <BaseButton3 @click="close" class="modal-edit-footer-button" :type="4">取消</BaseButton3>
        <BaseButton3 @click="commit" class="modal-edit-footer-button">保存</BaseButton3>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'

import {
  BaseButton3
} from '../button'

export default {
  components: {
    BaseModal,
    BaseButton3
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑'
        }
      }
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.modal-edit {
  & .modal-edit-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    background-color: var(--colorWhite);

    @media (--mediaPc) {
      height: fit-content;
      width: 600px;
      border-radius: var(--borderRadius1);
    }
    @media (--mediaMobile) {
      height: 100%;
      width: 100%;
    }
    & .icon {
      position: absolute;
      cursor: pointer;
      right: 12px;
      top: 12px;
      color: var(--color6);
    }
    & .modal-edit-header {
      background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_edit_popup_head.png');
      height: 116px;

      & .modal-edit-header-title {
        font-size: var(--textSize3);
        color: var(--colorWhite);
        padding: 18px;
      }
    }
    & .modal-edit-footer {
      text-align: center;
      padding: 35px 0;
      & .modal-edit-footer-button {
        margin: 0 20px;
        width: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/EditModal.vue